/* global localize */
import React, { useContext, Fragment } from 'react';
import { motion } from 'framer-motion';
import { SurveyContext } from '../context/surveyContext';
import { Link } from 'react-router-dom';

export default function Infopage() {
  const { survey } = useContext(SurveyContext);
  return (
    <motion.div
      className='survey-content'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      {survey && (
        <Fragment>
          <div className='survey-content__container info-text'>
            <h4>Steg 2</h4>
            <h1>{survey.survey_intro_title}</h1>
            <p>{survey.survey_intro_text}</p>
            <p className='info-text__bold'>{survey.survey_intro_bold_text}</p>
            <Link to={`${localize.url}/fragor`} className='regular-link'>
              Fortsätt till fråga 1
            </Link>
          </div>
          <div className='button-group'>
            <Link to={`${localize.url}/start`} className='button'>
              Tillbaka
            </Link>
            <Link to={`${localize.url}/fragor`} className='button'>
              Fortsätt
            </Link>
          </div>
        </Fragment>
      )}
    </motion.div>
  );
}
